import { LockHttpClient } from './httpClient';
import userTokenService from './security/userTokenService';

export type LockingUser = {
  name: string;
  isLocked: boolean;
};

type ApiResponseData = {
  id: string;
  user: string;
  userId: string;
};

type ApiResponse = {
  data: ApiResponseData[];
};

// Get users who are locking a content. This direct request can be used for the scenarios in which useLock.tsx can't be used
export const getLockingUsers = async (
  projectId: number | string,
  contentThreadIdArray: number[]
) => {
  const emptyResponse = {
    name: '',
    isLocked: false,
  };

  try {
    if (projectId && contentThreadIdArray?.length > 0) {
      const response = (await LockHttpClient(projectId).post(
        `/v1/projects/${projectId}/locks`,
        {
          ids: contentThreadIdArray,
        }
      )) as ApiResponse;

      if (response?.data && response.data.length > 0) {
        const lockingUser = response.data.find(
          (content) =>
            content.id === String(contentThreadIdArray[0]) &&
            String(content.userId) !== userTokenService.getUserId()
        );
        if (lockingUser) {
          return { name: lockingUser.user, isLocked: true };
        }
      }
    }

    return emptyResponse;
  } catch (e) {
    return emptyResponse;
  }
};
